import type { ApiRequestParams, ApiSchemas } from '$lib/api/shopwareApi.js';
import type { CreateMutationResult } from '@tanstack/svelte-query';
import type { Readable } from 'svelte/store';

export const ADD_TO_CART_CONTEXT_KEY = 'ADD_TO_CART_CONTEXT_KEY';

export interface AddToCartContext {
    addToCart: (quantity: number) => Promise<void>;
    addToCartMutation: CreateMutationResult<void, unknown, ApiRequestParams<'addLineItem'>, unknown>;
    updateCartMutation: CreateMutationResult<void, unknown, ApiRequestParams<'updateLineItem'>, unknown>;
    product: Readable<ApiSchemas['Product']>;
    productSlug: string;
}
